import _defineProperty from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { actionChannel, call, delay, put, select, take } from 'redux-saga/effects';
import { clearSession, dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType, initApplicationFailure, initApplicationSuccess, logout, logoutSuccess, readCpxProcess, setConnectorKo, setConnectorOk, setConnectorVersionKo, setDcParamsRegistered, setDcParamsUnregistered, setLicenseAfterFormOK, setLicenseMonitoringLoading, setSessionKo, setSessionOk, setWsInitError, setWsInitLoading, startCpxMonitoring } from '../actions';
import { formatOpenSessionParams } from '../actions/config/commandParamsFormatters';
import commands from '../actions/config/commands';
import getCommandAction from '../actions/config/generateCommands';
import { API_TYPES, apiSections, dmpconnectInitActionConstants } from '../constants';
import { getApiType, getApplicationId, getConfigurationValue, getCpxReader, getCurrentPathname as getCurrentPathnameAccessor, getDcParams, getDmpConnectJSONVersion, getDmpConnectJSVersion, getEsCertificate, getLicensingGroupId, getMSSEsCertificates, getProductionMode, getRemoteControlAppName, getSessionId as getSessionIdAccessor, getSessionTimeout, getTseActive, getTseWhoami, isRemoteControlActive } from '../helpers/accessors';
import { sessionExists } from '../helpers/checks/sessionExists';
import { getSectionState } from "../helpers/common";
import { checkDMPConnectJSVersion } from '../rules/systemRules';
import { getSavedPinCode } from './errorHandlersSagas';
import { checkConnector, handleDmpParameters, handleGetAtcImmunizationCodes, handleGetCiSisCodes, handleGetInteropCodes, handleGetNosCodes } from './utilsSagas';
var getSessionId = function getSessionId(state) {
  return getSessionIdAccessor(state);
};
export var checkIfDcParamsRegistered = /*#__PURE__*/_regeneratorRuntime().mark(function checkIfDcParamsRegistered(dcParams) {
  var sectionState, result;
  return _regeneratorRuntime().wrap(function checkIfDcParamsRegistered$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return select(getSectionState, apiSections.IS_REGISTERED_DC_PARAMS);
      case 2:
        sectionState = _context.sent;
        if (!sectionState.loading) {
          _context.next = 5;
          break;
        }
        return _context.abrupt("return", null);
      case 5:
        _context.next = 7;
        return put(getCommandAction(commands.isDcParamsRegistered, apiSections.IS_REGISTERED_DC_PARAMS, dcParams, {
          silentError: true
        }));
      case 7:
        _context.next = 9;
        return take([dmpCommandSuccessContextualizedType(apiSections.IS_REGISTERED_DC_PARAMS), dmpCommandFailureContextualizedType(apiSections.IS_REGISTERED_DC_PARAMS)]);
      case 9:
        result = _context.sent;
        if (!(result && result.type === dmpCommandSuccessContextualizedType(apiSections.IS_REGISTERED_DC_PARAMS))) {
          _context.next = 14;
          break;
        }
        return _context.abrupt("return", result.data && result.data.i_registered === 1);
      case 14:
        _context.next = 16;
        return put(setWsInitError(result.data));
      case 16:
        return _context.abrupt("return", null);
      case 17:
      case "end":
        return _context.stop();
    }
  }, checkIfDcParamsRegistered);
});
export var registerDcParameters = /*#__PURE__*/_regeneratorRuntime().mark(function registerDcParameters() {
  var sectionState, apiType, dcParams, isRegistered, result;
  return _regeneratorRuntime().wrap(function registerDcParameters$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return select(getSectionState, apiSections.REGISTER_DC_PARAMS);
      case 2:
        sectionState = _context2.sent;
        if (!sectionState.loading) {
          _context2.next = 5;
          break;
        }
        return _context2.abrupt("return", null);
      case 5:
        _context2.next = 7;
        return select(getApiType);
      case 7:
        apiType = _context2.sent;
        if (!(apiType === API_TYPES.REST)) {
          _context2.next = 13;
          break;
        }
        _context2.next = 11;
        return put(setWsInitError(null));
      case 11:
        _context2.next = 13;
        return put(setWsInitLoading(true));
      case 13:
        _context2.next = 15;
        return select(getDcParams);
      case 15:
        dcParams = _context2.sent;
        _context2.next = 18;
        return call(checkIfDcParamsRegistered, dcParams);
      case 18:
        isRegistered = _context2.sent;
        if (!(isRegistered === false)) {
          _context2.next = 46;
          break;
        }
        _context2.next = 22;
        return put(getCommandAction(commands.registerDcParams, apiSections.REGISTER_DC_PARAMS, dcParams));
      case 22:
        _context2.next = 24;
        return take([dmpCommandSuccessContextualizedType(apiSections.REGISTER_DC_PARAMS), dmpCommandFailureContextualizedType(apiSections.REGISTER_DC_PARAMS)]);
      case 24:
        result = _context2.sent;
        if (!(result && result.type === dmpCommandSuccessContextualizedType(apiSections.REGISTER_DC_PARAMS))) {
          _context2.next = 37;
          break;
        }
        _context2.next = 28;
        return put(setDcParamsRegistered());
      case 28:
        if (!(apiType !== API_TYPES.REST)) {
          _context2.next = 33;
          break;
        }
        _context2.next = 31;
        return put(setConnectorOk());
      case 31:
        _context2.next = 35;
        break;
      case 33:
        _context2.next = 35;
        return put(setWsInitError(null));
      case 35:
        _context2.next = 44;
        break;
      case 37:
        if (!(apiType !== API_TYPES.REST)) {
          _context2.next = 42;
          break;
        }
        _context2.next = 40;
        return put(initApplicationFailure(result.data));
      case 40:
        _context2.next = 44;
        break;
      case 42:
        _context2.next = 44;
        return put(setWsInitError(result.data));
      case 44:
        _context2.next = 67;
        break;
      case 46:
        if (!(isRegistered === true)) {
          _context2.next = 58;
          break;
        }
        _context2.next = 49;
        return put(setDcParamsRegistered());
      case 49:
        if (!(apiType !== API_TYPES.REST)) {
          _context2.next = 54;
          break;
        }
        _context2.next = 52;
        return put(setConnectorOk());
      case 52:
        _context2.next = 56;
        break;
      case 54:
        _context2.next = 56;
        return put(setWsInitError(null));
      case 56:
        _context2.next = 67;
        break;
      case 58:
        if (!(apiType !== API_TYPES.REST)) {
          _context2.next = 67;
          break;
        }
        _context2.next = 61;
        return put(setConnectorKo());
      case 61:
        _context2.next = 63;
        return put(initApplicationFailure());
      case 63:
        _context2.next = 65;
        return delay(5000);
      case 65:
        _context2.next = 67;
        return call(registerDcParameters);
      case 67:
      case "end":
        return _context2.stop();
    }
  }, registerDcParameters);
});
export var unregisterDcParameters = /*#__PURE__*/_regeneratorRuntime().mark(function unregisterDcParameters() {
  var dcParams, isRegistered;
  return _regeneratorRuntime().wrap(function unregisterDcParameters$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return select(getDcParams);
      case 2:
        dcParams = _context3.sent;
        _context3.next = 5;
        return call(checkIfDcParamsRegistered, dcParams);
      case 5:
        isRegistered = _context3.sent;
        if (!(isRegistered === true)) {
          _context3.next = 13;
          break;
        }
        _context3.next = 9;
        return put(getCommandAction(commands.unregisterDcParams, apiSections.UNREGISTER_DC_PARAMS, dcParams));
      case 9:
        _context3.next = 11;
        return take(dmpCommandSuccessContextualizedType(apiSections.UNREGISTER_DC_PARAMS));
      case 11:
        _context3.next = 13;
        return put(setDcParamsUnregistered());
      case 13:
      case "end":
        return _context3.stop();
    }
  }, unregisterDcParameters);
});
var getMSSEsCertificate = function getMSSEsCertificate(_ref) {
  var dmpconnectESConfiguration = _ref.dmpconnectESConfiguration;
  return getConfigurationValue('esMssCertificate', dmpconnectESConfiguration);
};
var openSession = /*#__PURE__*/_regeneratorRuntime().mark(function openSession() {
  var dcParams, tseActive, tseWhoami, sessionId, pathname, productionMode, applicationId, remoteControlActive, remoteControlAppName, esCertificate, licensingGroupId, _yield$select, esMssCertificate, esMssImapCertificate, esMssSmtpCertificate, esMssWsCertificate, sessionTimeout, openSessionParams, sessionActive, createSession, sessionExistsResult, exists, _yield$take, type, data, s_commandName, apiType, s_serviceVersion, minimumVersion;
  return _regeneratorRuntime().wrap(function openSession$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.next = 2;
        return select(getDcParams);
      case 2:
        dcParams = _context4.sent;
        _context4.next = 5;
        return select(getTseActive);
      case 5:
        tseActive = _context4.sent;
        _context4.next = 8;
        return select(getTseWhoami);
      case 8:
        tseWhoami = _context4.sent;
        _context4.next = 11;
        return select(getSessionId);
      case 11:
        sessionId = _context4.sent;
        _context4.next = 14;
        return select(getCurrentPathnameAccessor);
      case 14:
        pathname = _context4.sent;
        _context4.next = 17;
        return select(getProductionMode);
      case 17:
        productionMode = _context4.sent;
        _context4.next = 20;
        return select(getApplicationId);
      case 20:
        applicationId = _context4.sent;
        _context4.next = 23;
        return select(isRemoteControlActive);
      case 23:
        remoteControlActive = _context4.sent;
        _context4.next = 26;
        return select(getRemoteControlAppName);
      case 26:
        remoteControlAppName = _context4.sent;
        _context4.next = 29;
        return select(getEsCertificate);
      case 29:
        esCertificate = _context4.sent;
        _context4.next = 32;
        return select(getLicensingGroupId);
      case 32:
        licensingGroupId = _context4.sent;
        _context4.next = 35;
        return select(getMSSEsCertificates);
      case 35:
        _yield$select = _context4.sent;
        esMssCertificate = _yield$select.esMssCertificate;
        esMssImapCertificate = _yield$select.esMssImapCertificate;
        esMssSmtpCertificate = _yield$select.esMssSmtpCertificate;
        esMssWsCertificate = _yield$select.esMssWsCertificate;
        _context4.next = 42;
        return select(getSessionTimeout);
      case 42:
        sessionTimeout = _context4.sent;
        openSessionParams = {
          dcParams: dcParams,
          tseWhoami: tseActive ? tseWhoami : null,
          prodMode: productionMode,
          applicationId: remoteControlActive ? "".concat(applicationId, "-").concat(remoteControlAppName.replace(' ', '-')) : applicationId,
          esMssConfig64: esMssCertificate,
          esMssImapConfig64: esMssImapCertificate,
          esMssSmtpConfig64: esMssSmtpCertificate,
          esMssWsConfig64: esMssWsCertificate,
          esConfig64: esCertificate,
          sessionTimeout: sessionTimeout,
          licensingGroupId: licensingGroupId
        };
        sessionActive = false;
        createSession = true; // If we have a session opened
        if (!sessionId) {
          _context4.next = 64;
          break;
        }
        _context4.next = 49;
        return put(getCommandAction(commands.sessionExists, apiSections.SESSION_EXISTS_SECTION, null, {
          synchronous: true,
          silentError: true
        }));
      case 49:
        _context4.next = 51;
        return take([dmpCommandSuccessContextualizedType(apiSections.SESSION_EXISTS_SECTION), dmpCommandFailureContextualizedType(apiSections.SESSION_EXISTS_SECTION)]);
      case 51:
        sessionExistsResult = _context4.sent;
        _context4.next = 54;
        return call(sessionExists, sessionExistsResult);
      case 54:
        exists = _context4.sent;
        if (exists) {
          _context4.next = 62;
          break;
        }
        _context4.next = 58;
        return put(logoutSuccess());
      case 58:
        _context4.next = 60;
        return put(clearSession());
      case 60:
        _context4.next = 64;
        break;
      case 62:
        sessionActive = true;
        createSession = false;
      case 64:
        if (!sessionActive) {
          _context4.next = 75;
          break;
        }
        if (!(pathname === '/')) {
          _context4.next = 75;
          break;
        }
        _context4.next = 68;
        return put(logoutSuccess());
      case 68:
        _context4.next = 70;
        return put(getCommandAction(commands.closeSession, apiSections.SESSION_SECTION, null, {
          synchronous: true
        }));
      case 70:
        _context4.next = 72;
        return take([dmpCommandSuccessContextualizedType(apiSections.SESSION_SECTION), dmpCommandFailureContextualizedType(apiSections.SESSION_SECTION)]);
      case 72:
        _context4.next = 74;
        return put(clearSession());
      case 74:
        createSession = true;
      case 75:
        if (!(createSession === true)) {
          _context4.next = 116;
          break;
        }
        _context4.next = 78;
        return put(getCommandAction(commands.openSession, apiSections.SESSION_SECTION, formatOpenSessionParams(openSessionParams), {
          synchronous: true,
          contextExtra: {
            forceModal: true
          }
        }));
      case 78:
        _context4.next = 80;
        return take([dmpCommandSuccessContextualizedType(apiSections.SESSION_SECTION), dmpCommandFailureContextualizedType(apiSections.SESSION_SECTION)]);
      case 80:
        _yield$take = _context4.sent;
        type = _yield$take.type;
        data = _yield$take.data;
        s_commandName = _yield$take.command.s_commandName;
        if (!(type === dmpCommandFailureContextualizedType(apiSections.SESSION_SECTION))) {
          _context4.next = 92;
          break;
        }
        _context4.next = 87;
        return put(setSessionKo());
      case 87:
        if (!(pathname !== '/')) {
          _context4.next = 90;
          break;
        }
        _context4.next = 90;
        return put(logout());
      case 90:
        _context4.next = 114;
        break;
      case 92:
        if (!(s_commandName === 'hl_openSession')) {
          _context4.next = 112;
          break;
        }
        _context4.next = 95;
        return select(getApiType);
      case 95:
        apiType = _context4.sent;
        // check dmpconnectjs version
        s_serviceVersion = data.s_serviceVersion;
        _context4.next = 99;
        return select(getDmpConnectJSVersion);
      case 99:
        minimumVersion = _context4.sent;
        if (!(apiType === API_TYPES.JSON)) {
          _context4.next = 104;
          break;
        }
        _context4.next = 103;
        return select(getDmpConnectJSONVersion);
      case 103:
        minimumVersion = _context4.sent;
      case 104:
        if (checkDMPConnectJSVersion(s_serviceVersion, minimumVersion)) {
          _context4.next = 112;
          break;
        }
        _context4.next = 107;
        return put(setConnectorVersionKo(s_serviceVersion));
      case 107:
        _context4.next = 109;
        return delay(5000);
      case 109:
        _context4.next = 111;
        return call(openSession, false);
      case 111:
        return _context4.abrupt("return");
      case 112:
        _context4.next = 114;
        return put(setSessionOk());
      case 114:
        _context4.next = 118;
        break;
      case 116:
        _context4.next = 118;
        return put(setSessionOk());
      case 118:
      case "end":
        return _context4.stop();
    }
  }, openSession);
});
var initStatesAndMonitoring = /*#__PURE__*/_regeneratorRuntime().mark(function initStatesAndMonitoring() {
  var pathname;
  return _regeneratorRuntime().wrap(function initStatesAndMonitoring$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return select(getCurrentPathnameAccessor);
      case 2:
        pathname = _context5.sent;
        _context5.next = 5;
        return call(handleGetInteropCodes);
      case 5:
        _context5.next = 7;
        return call(handleDmpParameters);
      case 7:
        _context5.next = 9;
        return call(handleGetNosCodes);
      case 9:
        _context5.next = 11;
        return call(handleGetCiSisCodes);
      case 11:
        _context5.next = 13;
        return call(handleGetAtcImmunizationCodes);
      case 13:
        _context5.next = 15;
        return put(initApplicationSuccess());
      case 15:
        if (!(pathname !== '/')) {
          _context5.next = 18;
          break;
        }
        _context5.next = 18;
        return put(startCpxMonitoring());
      case 18:
      case "end":
        return _context5.stop();
    }
  }, initStatesAndMonitoring);
});
var initJS2LightStates = /*#__PURE__*/_regeneratorRuntime().mark(function initJS2LightStates() {
  return _regeneratorRuntime().wrap(function initJS2LightStates$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _context6.next = 2;
        return put(initApplicationSuccess());
      case 2:
      case "end":
        return _context6.stop();
    }
  }, initJS2LightStates);
});
export var checkLicenseProcess = /*#__PURE__*/_regeneratorRuntime().mark(function checkLicenseProcess() {
  var cpxReader, result;
  return _regeneratorRuntime().wrap(function checkLicenseProcess$(_context7) {
    while (1) switch (_context7.prev = _context7.next) {
      case 0:
        _context7.next = 2;
        return put(setLicenseMonitoringLoading(true));
      case 2:
        _context7.next = 4;
        return select(getCpxReader);
      case 4:
        cpxReader = _context7.sent;
        _context7.next = 7;
        return put(readCpxProcess(getSavedPinCode(), cpxReader, false));
      case 7:
        _context7.next = 9;
        return take(dmpCommandSuccessContextualizedType(apiSections.CPX_CARD_SECTION));
      case 9:
        _context7.next = 11;
        return put(getCommandAction(commands.checkUserLicenseRight, apiSections.CHECK_LICENSE_USER_RIGHT));
      case 11:
        _context7.next = 13;
        return take([dmpCommandSuccessContextualizedType(apiSections.CHECK_LICENSE_USER_RIGHT), dmpCommandFailureContextualizedType(apiSections.CHECK_LICENSE_USER_RIGHT)]);
      case 13:
        result = _context7.sent;
        if (!(result && result.type === dmpCommandSuccessContextualizedType(apiSections.CHECK_LICENSE_USER_RIGHT))) {
          _context7.next = 17;
          break;
        }
        _context7.next = 17;
        return put(setLicenseAfterFormOK());
      case 17:
        _context7.next = 19;
        return put(setLicenseMonitoringLoading(false));
      case 19:
      case "end":
        return _context7.stop();
    }
  }, checkLicenseProcess);
});
export var handleDMPSequence = /*#__PURE__*/_regeneratorRuntime().mark(function handleDMPSequence() {
  var dmpProcesses, requestChannel, payload, apiType;
  return _regeneratorRuntime().wrap(function handleDMPSequence$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        dmpProcesses = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, dmpconnectInitActionConstants.DMPC_RESET_APPLICATION, unregisterDcParameters), dmpconnectInitActionConstants.DMPC_INIT_APPLICATION, registerDcParameters), dmpconnectInitActionConstants.DMPC_DCPARAMS_REGISTERED, checkConnector), dmpconnectInitActionConstants.DMPC_SET_CONNECTOR_CONFIG_OK, openSession), dmpconnectInitActionConstants.DMPC_SET_SESSION_OK, initStatesAndMonitoring), dmpconnectInitActionConstants.DMPC_LICENSE_CHECK, checkLicenseProcess);
        _context8.next = 3;
        return actionChannel(Object.keys(dmpProcesses));
      case 3:
        requestChannel = _context8.sent;
      case 4:
        if (!true) {
          _context8.next = 16;
          break;
        }
        _context8.next = 7;
        return take(requestChannel);
      case 7:
        payload = _context8.sent;
        _context8.next = 10;
        return select(getApiType);
      case 10:
        apiType = _context8.sent;
        if (!(apiType === API_TYPES.WS)) {
          _context8.next = 14;
          break;
        }
        _context8.next = 14;
        return call(dmpProcesses[payload.type], payload);
      case 14:
        _context8.next = 4;
        break;
      case 16:
      case "end":
        return _context8.stop();
    }
  }, handleDMPSequence);
});
export var handleJS2LightSequence = /*#__PURE__*/_regeneratorRuntime().mark(function handleJS2LightSequence() {
  var dmpProcesses, requestChannel, payload, apiType;
  return _regeneratorRuntime().wrap(function handleJS2LightSequence$(_context9) {
    while (1) switch (_context9.prev = _context9.next) {
      case 0:
        dmpProcesses = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, dmpconnectInitActionConstants.DMPC_RESET_APPLICATION, unregisterDcParameters), dmpconnectInitActionConstants.DMPC_INIT_APPLICATION, registerDcParameters), dmpconnectInitActionConstants.DMPC_DCPARAMS_REGISTERED, checkConnector), dmpconnectInitActionConstants.DMPC_SET_CONNECTOR_CONFIG_OK, openSession), dmpconnectInitActionConstants.DMPC_SET_SESSION_OK, initJS2LightStates), dmpconnectInitActionConstants.DMPC_LICENSE_CHECK, checkLicenseProcess);
        _context9.next = 3;
        return actionChannel(Object.keys(dmpProcesses));
      case 3:
        requestChannel = _context9.sent;
      case 4:
        if (!true) {
          _context9.next = 16;
          break;
        }
        _context9.next = 7;
        return take(requestChannel);
      case 7:
        payload = _context9.sent;
        _context9.next = 10;
        return select(getApiType);
      case 10:
        apiType = _context9.sent;
        if (!(apiType === API_TYPES.WS)) {
          _context9.next = 14;
          break;
        }
        _context9.next = 14;
        return call(dmpProcesses[payload.type], payload);
      case 14:
        _context9.next = 4;
        break;
      case 16:
      case "end":
        return _context9.stop();
    }
  }, handleJS2LightSequence);
});
export var handleJSPostSequence = /*#__PURE__*/_regeneratorRuntime().mark(function handleJSPostSequence() {
  var dmpProcesses, requestChannel, payload, apiType;
  return _regeneratorRuntime().wrap(function handleJSPostSequence$(_context10) {
    while (1) switch (_context10.prev = _context10.next) {
      case 0:
        dmpProcesses = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, dmpconnectInitActionConstants.DMPC_RESET_APPLICATION, unregisterDcParameters), dmpconnectInitActionConstants.DMPC_INIT_APPLICATION, registerDcParameters), dmpconnectInitActionConstants.DMPC_DCPARAMS_REGISTERED, openSession), dmpconnectInitActionConstants.DMPC_SET_SESSION_OK, initStatesAndMonitoring), dmpconnectInitActionConstants.DMPC_LICENSE_CHECK, checkLicenseProcess);
        _context10.next = 3;
        return actionChannel(Object.keys(dmpProcesses));
      case 3:
        requestChannel = _context10.sent;
      case 4:
        if (!true) {
          _context10.next = 16;
          break;
        }
        _context10.next = 7;
        return take(requestChannel);
      case 7:
        payload = _context10.sent;
        _context10.next = 10;
        return select(getApiType);
      case 10:
        apiType = _context10.sent;
        if (!(apiType === API_TYPES.JSPOST)) {
          _context10.next = 14;
          break;
        }
        _context10.next = 14;
        return call(dmpProcesses[payload.type], payload);
      case 14:
        _context10.next = 4;
        break;
      case 16:
      case "end":
        return _context10.stop();
    }
  }, handleJSPostSequence);
});
export var handleJSONSequence = /*#__PURE__*/_regeneratorRuntime().mark(function handleJSONSequence() {
  var dmpProcesses, requestChannel, payload, apiType;
  return _regeneratorRuntime().wrap(function handleJSONSequence$(_context11) {
    while (1) switch (_context11.prev = _context11.next) {
      case 0:
        dmpProcesses = _defineProperty(_defineProperty(_defineProperty({}, dmpconnectInitActionConstants.DMPC_INIT_APPLICATION, openSession), dmpconnectInitActionConstants.DMPC_SET_SESSION_OK, initStatesAndMonitoring), dmpconnectInitActionConstants.DMPC_LICENSE_CHECK, checkLicenseProcess);
        _context11.next = 3;
        return actionChannel(Object.keys(dmpProcesses));
      case 3:
        requestChannel = _context11.sent;
      case 4:
        if (!true) {
          _context11.next = 16;
          break;
        }
        _context11.next = 7;
        return take(requestChannel);
      case 7:
        payload = _context11.sent;
        _context11.next = 10;
        return select(getApiType);
      case 10:
        apiType = _context11.sent;
        if (!(apiType === API_TYPES.JSON)) {
          _context11.next = 14;
          break;
        }
        _context11.next = 14;
        return call(dmpProcesses[payload.type], payload);
      case 14:
        _context11.next = 4;
        break;
      case 16:
      case "end":
        return _context11.stop();
    }
  }, handleJSONSequence);
});